import { render, staticRenderFns } from "./NotaRecurso.vue?vue&type=template&id=30e807ee&"
import script from "./NotaRecurso.vue?vue&type=script&lang=js&"
export * from "./NotaRecurso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports